/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Microsoft Fabric integration configuration
*/
export class MicrosoftFabricIntegrationConfig {
  'tenantId'?: string;
  'subscriptionId'?: string;
  'appId'?: string;
  'connectionId'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "tenantId",
      "baseName": "tenantId",
      "type": "string",
      "format": ""
    },
    {
      "name": "subscriptionId",
      "baseName": "subscriptionId",
      "type": "string",
      "format": ""
    },
    {
      "name": "appId",
      "baseName": "appId",
      "type": "string",
      "format": ""
    },
    {
      "name": "connectionId",
      "baseName": "connectionId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return MicrosoftFabricIntegrationConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

